import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InvoiceStatusMap } from '@application/common/enums/invoice-status';
import { convertBase64toBlob, convertToPdfFile, getMimeTypeFromBase64 } from '@application/common/helpers/file-helper';
import { translate } from '@application/common/helpers/translate';
import { getFreelancerAssignmentByApprovedTimsheetAsync } from '@application/features/assignments/assignmentThunk';
import { downloadCOCDocumentAsync, getFreelancerAsync } from '@application/features/freelancer/freelancerThunks';
import { resetMonthList, resetYearList } from '@application/features/HoursRegistration/hoursRegistrationSlice';
import { getMonthListByAssignmentAndFreelancerId, getYearListByAssignmentAndFreelancerId } from '@application/features/HoursRegistration/hoursRegistrationThunk';
import { AddUpdateInvoice, getByInvoiceId } from '@application/features/invoices/invoiceThunk';
import { getFilteredInvoicePackagesAsync } from '@application/features/Packages/packageThunk';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { DownloadAction } from '@ui/components/common/actions/DownloadAction';
import { UploadAction } from '@ui/components/common/actions/UploadAction';
import { PrimaryButon } from '@ui/components/common/button/PrimaryButon';
import { WidgetHeader } from '@ui/components/common/header/widgetHeader/WidgetHeader';
import CustomSelect from '@ui/components/common/inputs/CustomSelect';
import { QNumericInput } from '@ui/components/common/inputs/NumericInput';
import { QInput } from '@ui/components/common/inputs/QInput';
import { QTextArea } from '@ui/components/common/inputs/QTextArea';
import { QCheckbox } from '@ui/components/common/Qcheckbox/QCheckbox';
import { black500 } from '@ui/constants/color';
import { colCenter } from '@ui/style/style';
import { CloseCircle } from 'iconsax-react';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
export const AddInvoice = ({ open, handleClose, type = 'add', updateParentYearAndMonth, invoiceId }) => {
    const dispatch = useAppDispatch();
    const [uploadedFile, setUploadedFile] = useState(null);
    const [isFileUploaded, setIsFileUploaded] = useState(false);
    const [inclusiveBtw, setInclusiveBtw] = useState(0);
    const [showUploadAction, setShowUploadAction] = useState(false);
    const [allDocumentsUploadedFiles, setInvoiceDocumentsUploadedFiles] = useState([]);
    const { AssignmentsForInvoice } = useAppSelector((state) => state.assignment);
    const { filteredInvoicePackages } = useAppSelector((state) => state.packages);
    const { monthList } = useAppSelector((state) => state.hoursRegistration);
    const { yearList } = useAppSelector((state) => state.hoursRegistration);
    const { singleInvoice } = useAppSelector((state) => state.invoice);
    const [reason, setReason] = useState('');
    const allowedFileTypes = [
        'application/pdf'
        //,
        // 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        // 'application/vnd.ms-excel',
        // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ];
    const { control, handleSubmit, formState: { errors }, trigger, setValue, setError, clearErrors, reset, getValues } = useForm({
        mode: 'onChange',
        defaultValues: {
            btwPercent: 21,
            amountExclusiveBtw: 1,
            isCorrectDebtor: false,
            isCorrectVAT: false,
            isMatchApprovedHours: false,
            isTermAndCondition: false
        }
    });
    const isDisabled = type === 'edit' && InvoiceStatusMap.get(getValues('invoiceStatus')) === 'Pending';
    useEffect(() => {
        dispatch(getFilteredInvoicePackagesAsync());
        dispatch(getFreelancerAssignmentByApprovedTimsheetAsync());
    }, [dispatch]);
    useEffect(() => {
        if (open && type === 'add') {
            setIsFileUploaded(false);
            dispatch(getFreelancerAsync())
                .unwrap()
                .then((resp) => {
                const defaultPlan = filteredInvoicePackages &&
                    (filteredInvoicePackages.find((plan) => plan.id === resp.userPlanId) || filteredInvoicePackages[0]);
                reset({
                    assignmentId: '',
                    amountExclusiveBtw: 1,
                    btwPercent: 21,
                    month: null,
                    year: null,
                    invoiceStatus: 0,
                    planId: defaultPlan ? defaultPlan.id : '',
                    isCorrectDebtor: false,
                    isCorrectVAT: false,
                    isMatchApprovedHours: false,
                    isTermAndCondition: false
                });
                setShowUploadAction(true);
                setUploadedFile(null);
                CalculateInclusiveAmount(1);
            })
                .catch((err) => { });
        }
        else {
            reset({
                assignmentId: '',
                amountExclusiveBtw: 0,
                btwPercent: 0,
                month: null,
                year: null,
                invoiceStatus: 0,
                planId: '',
                isCorrectDebtor: false,
                isCorrectVAT: false,
                isMatchApprovedHours: false,
                isTermAndCondition: false
            });
            if (invoiceId) {
                dispatch(getByInvoiceId(invoiceId))
                    .unwrap()
                    .then((invoiceResponse) => {
                    let yearRequest = {
                        assignmentId: invoiceResponse.assignmentId,
                        id: invoiceId
                    };
                    dispatch(getYearListByAssignmentAndFreelancerId(yearRequest))
                        .unwrap()
                        .then((yearResponse) => {
                        const request = {
                            assignmentId: invoiceResponse.assignmentId,
                            year: invoiceResponse.year,
                            id: invoiceId
                        };
                        dispatch(getMonthListByAssignmentAndFreelancerId(request))
                            .unwrap()
                            .then((monthAndListResponse) => {
                            const plan = filteredInvoicePackages?.some((x) => x.id == invoiceResponse.invoicePlanId);
                            reset({
                                assignmentId: invoiceResponse?.assignmentId,
                                amountExclusiveBtw: invoiceResponse?.amountExclBTW,
                                btwPercent: invoiceResponse?.btw,
                                invoiceStatus: invoiceResponse?.invoiceStatus,
                                isCorrectDebtor: invoiceResponse?.invoiceChecklist.isCorrectDebtor,
                                isCorrectVAT: invoiceResponse?.invoiceChecklist.isCorrectVAT,
                                isMatchApprovedHours: invoiceResponse?.invoiceChecklist.isMatchApprovedHours,
                                isTermAndCondition: invoiceResponse?.invoiceChecklist.isTermAndCondition,
                                month: invoiceResponse.month,
                                planId: plan ? invoiceResponse?.invoicePlanId : undefined,
                                year: invoiceResponse?.year,
                                Id: invoiceResponse.id
                            });
                            CalculateInclusiveAmount(invoiceResponse?.amountExclBTW);
                            setInvoiceDocumentsUploadedFiles(invoiceResponse.invoiceDocuments);
                            setReason(invoiceResponse?.reason);
                            setIsFileUploaded(true);
                            if (!open) {
                                dispatch(resetMonthList());
                            }
                        });
                    })
                        .catch();
                });
            }
        }
        if (!open) {
            reset({
                assignmentId: '',
                amountExclusiveBtw: 0,
                btwPercent: 0,
                month: null,
                year: null,
                invoiceStatus: 0,
                planId: '',
                isCorrectDebtor: false,
                isCorrectVAT: false,
                isMatchApprovedHours: false,
                isTermAndCondition: false
            });
            setShowUploadAction(false);
            setUploadedFile(null);
            setInvoiceDocumentsUploadedFiles([]);
            setReason('');
            setIsFileUploaded(false);
            dispatch(resetMonthList());
            dispatch(resetYearList());
        }
    }, [dispatch, invoiceId, open, type, filteredInvoicePackages, reset]);
    const customAmountValidator = (val) => {
        const value = val.toString();
        // Ensure the value is treated as a string
        const normalizedValue = value.toString().trim();
        // Remove any thousands separator (.)
        const sanitizedValue = normalizedValue.replace(/\./g, '');
        // Split the value into the whole part and fractional part after the comma
        const parts = sanitizedValue.split(',');
        const numericValue = parseFloat(value.replace(',', '.'));
        if (Number(parts[0]) <= 0) {
            return 'Amount cannot be less than 1';
        }
        // Validate that there are at most two digits after the comma
        if (parts.length > 2 || (parts[1] && parts[1].length > 2)) {
            return 'Amount can have up to two digits after the comma';
        }
        // Validate that the whole part is numeric (after removing thousands separator)
        const mainPart = parts[0];
        if (!/^\d+$/.test(mainPart)) {
            return 'Amount must be numeric';
        }
        // If there's a fractional part, validate that it is numeric and does not exceed two digits
        if (parts[1] && !/^\d{1,2}$/.test(parts[1])) {
            return 'Amount can have up to two digits after the comma';
        }
        // If everything is fine, return true
        return true;
    };
    const onSubmit = (data) => {
        if (data.invoiceDocument && !allowedFileTypes.includes(data.invoiceDocument.type)) {
            setError('invoiceDocument', { message: translate('validations.invoiceDocumentAllowed') });
            return;
        }
        if (data.invoiceDocument && data.invoiceDocument.size > 1048576) {
            setError('invoiceDocument', { message: translate('validations.maxAllowedFileSize') });
            return;
        }
        if (type === 'add') {
            dispatch(AddUpdateInvoice(data))
                .unwrap()
                .then((response) => {
                if (response) {
                    handleClose();
                    const selectedMonth = getValues('month');
                    const selectedYear = getValues('year');
                    if (selectedMonth && selectedYear) {
                        updateParentYearAndMonth(selectedYear.toString(), selectedMonth);
                    }
                    setIsFileUploaded(false);
                }
            })
                .catch((x) => { });
        }
        else {
            data.Id = invoiceId;
            dispatch(AddUpdateInvoice(data))
                .unwrap()
                .then((response) => {
                if (response) {
                    handleClose();
                    const selectedMonth = getValues('month');
                    const selectedYear = getValues('year');
                    if (selectedMonth && selectedYear) {
                        updateParentYearAndMonth(selectedYear.toString(), selectedMonth);
                    }
                    setIsFileUploaded(false);
                }
            })
                .catch((x) => { });
        }
    };
    const CalculateInclusiveAmount = (value) => {
        const btw = getValues('btwPercent');
        if (!isNaN(value) && btw && btw < 100) {
            // old calculation formula const inclusiveAmount = value * (1 - btw / 100);
            //#region updated calculation farmula
            const inclusiveAmount = value * (1 + btw / 100);
            const roundedAmount = parseFloat(inclusiveAmount.toFixed(2));
            //#endregion
            return setInclusiveBtw(roundedAmount);
        }
        return setInclusiveBtw(0);
    };
    const GetYearsOnClientChange = (event) => {
        let invoiceId = getValues('Id');
        const yearRequest = {
            id: invoiceId === undefined ? null : invoiceId,
            assignmentId: event.target.value
        };
        dispatch(resetMonthList());
        dispatch(getYearListByAssignmentAndFreelancerId(yearRequest))
            .unwrap()
            .then((resp) => {
            setValue('year', null);
            setValue('month', null);
        })
            .catch();
        setValue('assignmentId', event.target.value, { shouldValidate: true });
    };
    const handleFileUpload = (file) => {
        setUploadedFile(file);
        setIsFileUploaded(true);
        if (file) {
            const maxFileSize = 1048576;
            if (!allowedFileTypes.includes(file.type))
                setError('invoiceDocument', {
                    message: translate('validations.invoiceDocumentAllowed')
                });
            else if (file.size > maxFileSize) {
                setError('invoiceDocument', {
                    message: translate('validations.maxAllowedFileSize')
                });
            }
            else {
                setValue('invoiceDocument', file);
                clearErrors('invoiceDocument');
            }
        }
        else {
            clearErrors('invoiceDocument');
            setIsFileUploaded(false);
        }
    };
    const handlePlanChange = (event) => {
        setValue('planId', event.target.value, { shouldValidate: true });
    };
    const handleYearChange = (event) => {
        let assignmentId = getValues('assignmentId');
        if (event.target.value && assignmentId) {
            let invoiceId = getValues('Id');
            const request = {
                id: invoiceId === undefined ? null : invoiceId,
                assignmentId: assignmentId,
                year: parseInt(event.target.value)
            };
            dispatch(getMonthListByAssignmentAndFreelancerId(request))
                .unwrap()
                .then((resp) => {
                setValue('month', null, { shouldValidate: false });
            })
                .catch();
        }
        setValue('year', parseInt(event.target.value), { shouldValidate: true });
    };
    const handleMonthChange = (event) => {
        setValue('month', parseInt(event.target.value), { shouldValidate: true });
    };
    const convertInvoiceDOcumentToPDF = (invoiceDocument) => {
        const fileDto = { folderName: invoiceDocument?.folderName, fileName: invoiceDocument?.name };
        dispatch(downloadCOCDocumentAsync(fileDto))
            .unwrap()
            .then((res) => {
            const mimeType = getMimeTypeFromBase64(res.file);
            if (mimeType === 'application/pdf') {
                const pdfWindow = window.open();
                if (!pdfWindow) {
                    return;
                }
                pdfWindow.document.write(`<title>${invoiceDocument?.name || 'Chamber of Commerce Document'}</title>`);
                pdfWindow.document.write(`<iframe width='100%' height='100%' src='data:${mimeType};base64,${encodeURIComponent(res.file)}'></iframe>`);
            }
            else {
                const blob = convertBase64toBlob(res.file, mimeType ?? '');
                if (!blob) {
                    console.error('Failed to create Blob from the base64 string.');
                    return;
                }
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = invoiceDocument?.name || 'download';
                link.click();
                URL.revokeObjectURL(url);
            }
        });
    };
    const clearFile = (fileName) => {
        const updatedFiles = allDocumentsUploadedFiles.filter((file) => (file.fileData && file.fileData.name !== fileName) || (file.name && file.name != fileName));
        if (updatedFiles.length > 0) {
            convertFileIntoBlobFile(updatedFiles);
        }
        if (updatedFiles.length === 0) {
            clearErrors('invoiceDocument');
            setShowUploadAction(true);
        }
        setIsFileUploaded(false);
        setInvoiceDocumentsUploadedFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
    };
    const convertFileIntoBlobFile = async (uploadedAzureFiles) => {
        if (uploadedAzureFiles && uploadedAzureFiles.length > 0) {
            const fileDto = { folderName: uploadedAzureFiles[0].folderName, fileName: uploadedAzureFiles[0].name };
            try {
                const res = await dispatch(downloadCOCDocumentAsync(fileDto)).unwrap();
                const blob = convertToPdfFile(res.file);
                const blobFile = new File([blob], uploadedAzureFiles[0]?.name ?? '', { type: 'application/pdf' });
                setValue('invoiceDocument', blobFile);
            }
            catch (error) { }
        }
    };
    const handleCloseDialog = () => {
        handleClose();
        reset();
        setUploadedFile(null);
        setInvoiceDocumentsUploadedFiles([]);
    };
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    return (_jsxs(Dialog, { open: open, onClose: handleClose, maxWidth: false, BackdropProps: {
            sx: {
                backdropFilter: 'blur(3px)',
                backgroundColor: 'rgba(74, 74, 74, 0.25)'
            }
        }, children: [_jsx(DialogTitle, { style: { padding: 0 }, children: _jsxs(WidgetHeader, { background: 'white', children: [_jsx(Typography, { fontWeight: 500, fontSize: '20px', color: 'black', children: (() => {
                                const invoiceStatus = InvoiceStatusMap.get(getValues('invoiceStatus'));
                                if (type == 'edit' && invoiceStatus === 'Pending') {
                                    return 'View Invoice';
                                }
                                else if (invoiceStatus === 'Rejected') {
                                    return 'Edit Invoice';
                                }
                                else {
                                    return type === 'add' ? 'Add Invoice' : 'Edit Invoice';
                                }
                            })() }), _jsx(IconButton, { onClick: handleCloseDialog, children: _jsx(CloseCircle, { style: { color: 'black' } }) })] }) }), _jsx(DialogContent, { children: _jsxs(Box, { p: isSmallScreen ? 1 : 2, children: [_jsxs(Box, { sx: {
                                display: 'flex',
                                flexDirection: isSmallScreen ? 'column' : 'row',
                                gap: 2
                            }, children: [_jsxs(Box, { sx: {
                                        flex: 1
                                    }, children: [_jsx(Typography, { variant: 'subtitle2', color: black500, children: "Plan" }), !isDisabled && (_jsx(Controller, { name: 'planId', control: control, rules: { required: 'This field is required' }, defaultValue: '', render: ({ field }) => (_jsx(CustomSelect, { options: filteredInvoicePackages
                                                    ? filteredInvoicePackages?.map((data) => ({
                                                        label: data.name,
                                                        value: data.id
                                                    }))
                                                    : [], label: 'Plan', selectedOption: field.value, defaultOption: 'No plan available', handleChange: handlePlanChange, errormsg: errors.planId ? errors.planId.message : '', disabled: isDisabled })) })), isDisabled && InvoiceStatusMap.get(getValues('invoiceStatus')) === 'Pending' && (_jsx(Controller, { name: 'planId', control: control, defaultValue: '', render: ({ field }) => (_jsx(QInput, { ...field, value: singleInvoice?.invoicePackageName, disabled: true, errormsg: errors.planId ? errors.planId.message : '' })) }))] }), _jsxs(Box, { sx: {
                                        flex: 1
                                    }, children: [_jsx(Typography, { variant: 'subtitle2', color: black500, children: "Client" }), _jsx(Controller, { name: 'assignmentId', control: control, rules: { required: 'This field is required' }, defaultValue: '', render: ({ field }) => (_jsx(CustomSelect, { options: AssignmentsForInvoice
                                                    ? AssignmentsForInvoice.map((client) => ({
                                                        label: client.clientName,
                                                        value: client.id
                                                    }))
                                                    : [], label: 'Client', selectedOption: field.value, defaultOption: 'No approved client', handleChange: GetYearsOnClientChange, errormsg: errors.assignmentId ? errors.assignmentId.message : '', disabled: isDisabled })) })] })] }), _jsxs(Box, { sx: { ...colCenter, flexDirection: isSmallScreen ? 'column' : 'row  ', gap: 2, mt: 2 }, children: [_jsxs(Box, { width: '100%', children: [_jsx(Typography, { variant: 'subtitle2', color: black500, children: "Year" }), _jsx(Controller, { name: 'year', control: control, rules: { required: 'This field is required' }, defaultValue: type == 'add' ? undefined : 0, render: ({ field }) => (_jsx(CustomSelect, { options: yearList
                                                    ? yearList?.map((year) => ({
                                                        label: year.name,
                                                        value: year.id
                                                    }))
                                                    : [], label: 'Year', selectedOption: field.value || '', defaultOption: 'No year with approved hours', handleChange: (event) => {
                                                    let value = event.target.value;
                                                    field.onChange(value);
                                                    handleYearChange(event);
                                                }, errormsg: errors.year ? errors.year.message : '', disabled: isDisabled })) })] }), _jsxs(Box, { width: '100%', children: [_jsx(Typography, { variant: 'subtitle2', color: black500, children: "Month" }), _jsx(Controller, { name: 'month', control: control, rules: { required: 'This field is required' }, defaultValue: type == 'add' ? undefined : 0, render: ({ field }) => (_jsx(CustomSelect, { options: monthList
                                                    ? monthList?.map((month) => ({
                                                        label: month.name,
                                                        value: month.id
                                                    }))
                                                    : [], label: 'Month', selectedOption: field.value || '', defaultOption: 'No month with approved hours', handleChange: (event) => {
                                                    let value = event.target.value;
                                                    field.onChange(value);
                                                    handleMonthChange(event);
                                                }, errormsg: errors.month ? errors.month.message : '', disabled: isDisabled })) })] })] }), _jsxs(Box, { sx: { ...colCenter, flexDirection: isSmallScreen ? 'column' : 'row  ', gap: 2, mt: 2 }, children: [_jsx(Controller, { name: 'btwPercent', control: control, render: ({ field }) => (_jsx(QInput, { ...field, label: 'BTW %', value: '21', disabled: true, errormsg: errors.btwPercent ? errors.btwPercent.message : '' })) }), _jsx(Controller, { name: 'amountExclusiveBtw', control: control, rules: {
                                        required: 'This field is required',
                                        min: { value: 1, message: 'Amount cannot be less than 1' },
                                        validate: {
                                            validate: customAmountValidator
                                        }
                                    }, render: ({ field }) => (_jsx(QNumericInput, { label: 'Amount Exclusive BTW', ...field, thousandSeparator: '.', decimalSeparator: ',', allowNegative: false, decimalScale: 2, fixedDecimalScale: true, disabled: isDisabled, onValueChange: (values) => {
                                            let { value } = values;
                                            let sanitizedValue = value.replace(/[^0-9,\.]/g, '');
                                            field.onChange(sanitizedValue);
                                            setTimeout(() => {
                                                trigger('amountExclusiveBtw');
                                            });
                                            CalculateInclusiveAmount(parseFloat(sanitizedValue.replace(',', '.')));
                                        }, errormsg: errors.amountExclusiveBtw && errors.amountExclusiveBtw.message })) })] }), _jsxs(Box, { mt: 2, display: 'flex', sx: { flexDirection: isSmallScreen ? 'column' : 'row  ' }, height: '100%', gap: 2, alignItems: 'center', children: [_jsx(Box, { width: isSmallScreen ? '100%' : '50%', children: _jsx(QInput, { label: 'Amount inclusive BTW', value: inclusiveBtw ? Number(inclusiveBtw).toLocaleString('nl', { maximumFractionDigits: 2 }) : '', disabled: true }) }), _jsx(Box, { width: isSmallScreen ? '100%' : '50%', mt: 3, height: '100%', children: showUploadAction && allDocumentsUploadedFiles.length === 0 ? (_jsx(Controller, { name: 'invoiceDocument', control: control, rules: {
                                            required: { value: true, message: translate('validations.fieldIsRequired') },
                                            validate: {
                                                fileType: (file) => {
                                                    if (file && !allowedFileTypes.includes(file.type)) {
                                                        return translate('validations.invoiceDocumentAllowed');
                                                    }
                                                    return true;
                                                },
                                                fileSize: (file) => {
                                                    if (file && file.size > 1048576) {
                                                        return translate('validations.maxAllowedFileSize');
                                                    }
                                                    return true;
                                                }
                                            }
                                        }, render: ({ field }) => {
                                            return (_jsx(UploadAction, { onFileUpload: (file) => {
                                                    field.onChange(file);
                                                    handleFileUpload(file);
                                                }, h: isFileUploaded ? 70 : 55, titleFont: '12px', singleFile: true, py: isFileUploaded ? 0 : 15, direction: 'col', subtitleFont: '8px', variant: isFileUploaded ? 'outLined' : 'contained', text: 'Upload invoice', px: isFileUploaded ? 5 : 0, errormsg: errors.invoiceDocument ? errors.invoiceDocument.message : '' }));
                                        } })) : (allDocumentsUploadedFiles.map((item) => {
                                        return (_jsx(Box, { mt: 0.5, children: _jsx(Controller, { name: 'invoiceDocument', control: control, render: ({ field }) => (_jsx(DownloadAction, { width: '100%', fileName: item?.name, haveClear: InvoiceStatusMap.get(getValues('invoiceStatus')) === 'Rejected' ? true : false, type: 'download', clear: () => clearFile(item.name), onClick: () => {
                                                        convertInvoiceDOcumentToPDF(item);
                                                    } })) }) }));
                                    })) })] }), _jsxs(Box, { sx: {
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: 2,
                                mt: 1
                            }, children: [type === 'edit' && InvoiceStatusMap.get(getValues('invoiceStatus')) === 'Rejected' && (_jsxs(Box, { width: '50%', children: [_jsx(Typography, { variant: 'subtitle2', color: black500, children: "Reason for decline" }), _jsx(QTextArea, { rows: 6, value: reason, disabled: true })] })), _jsxs(Box, { width: type === 'edit' ? '50%' : '100%', children: [_jsx(Controller, { name: 'isCorrectDebtor', control: control, rules: { required: 'This field is required' }, disabled: isDisabled, render: ({ field }) => (_jsx(QCheckbox, { ...field, label: 'Correct debtor', checked: field.value, onChange: (e) => {
                                                    field.onChange(e);
                                                }, checkboxProps: { disabled: isDisabled }, errormsg: errors.isCorrectDebtor ? errors.isCorrectDebtor.message : '' })) }), _jsx(Controller, { name: 'isCorrectVAT', control: control, rules: { required: 'This field is required' }, render: ({ field }) => (_jsx(QCheckbox, { ...field, label: 'VAT correctly stated on the invoice', checked: field.value, onChange: (e) => {
                                                    field.onChange(e);
                                                }, checkboxProps: { disabled: isDisabled }, errormsg: errors.isCorrectVAT ? errors.isCorrectVAT.message : '' })) }), _jsx(Controller, { name: 'isMatchApprovedHours', control: control, rules: { required: 'This field is required' }, disabled: isDisabled, render: ({ field }) => (_jsx(QCheckbox, { ...field, label: 'The hours on the invoice match the approved hours', checked: field.value, onChange: (e) => {
                                                    field.onChange(e);
                                                }, checkboxProps: { disabled: isDisabled }, errormsg: errors.isMatchApprovedHours ? errors.isMatchApprovedHours.message : '' })) }), _jsx(Controller, { name: 'isTermAndCondition', control: control, rules: { required: 'This field is required' }, disabled: isDisabled, render: ({ field }) => (_jsx(QCheckbox, { ...field, label: 'When uploading the invoice, I agree to the terms and conditions and declare that all information has been filled in truthfully.', checked: field.value, onChange: (e) => {
                                                    field.onChange(e);
                                                }, checkboxProps: { disabled: isDisabled }, errormsg: errors.isTermAndCondition ? errors.isTermAndCondition.message : '' })) })] })] })] }) }), _jsx(DialogActions, { style: { padding: '10px 15px' }, children: ((type === 'add' && InvoiceStatusMap.get(getValues('invoiceStatus')) === 'Pending') ||
                    (type === 'edit' && InvoiceStatusMap.get(getValues('invoiceStatus')) === 'Rejected')) && (_jsx(Box, { width: '50%', children: _jsxs(PrimaryButon, { onClick: handleSubmit(onSubmit), children: [type === 'add' ? 'Add' : 'Edit', " Invoice"] }) })) })] }));
};
